import { createBrowserRouter, createRoutesFromElements, Route, Navigate } from 'react-router-dom';
import PrivateRoute from './routes/PrivateRoute';
import Dashboard from './pages/Dashboard/Dashboard';
import Login from './pages/Login/Login';
import VinDetailsPage from './pages/VinDetails/VinDetailsPage';
import Profile from './pages/Profile/Profile';
import NotFound from './pages/NotFound/NotFound';

const App = createBrowserRouter(
  createRoutesFromElements(
    <Route path="/">
      <Route index element={<Login />} />

      {/* PUBLIC ROUTES */}
      <Route path="login" element={<Navigate to="/" replace />} />

      {/* PROTECTED ROUTES - Wrapped with PrivateRoute layout */}
      <Route element={<PrivateRoute />}>
        <Route path="dashboard" element={<Dashboard />} />
        <Route path="vin/:vinId" element={<VinDetailsPage />} />
        <Route path="profile" element={<Profile />} />
      </Route>

      {/* CATCH ALL - Redirect to login or dashboard based on auth status */}
      <Route path="*" element={<NotFound />} />
    </Route>
  )
);

export default App;
